import PublicHeader from "../components/PublicHeader"
import { Outlet } from 'react-router-dom';

export default function PublicLayout({ children }) {

    return (
        <div>
            <PublicHeader />
            <main>
                <Outlet />
            </main>

        </div>
    )
}